import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RedirectToDashboard: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    navigate(`/dashboard`, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default RedirectToDashboard;
